/**
 * Logo Component - gold α + white bet
 */

import './Logo.css'

function Logo({ onLogoClick = () => {} }) {
  return (
    <button className="logo-btn" onClick={onLogoClick}>
      <span className="alpha">{'\u03B1'}</span>
      <span className="bet">bet</span>
    </button>
  )
}

export default Logo
